var React = require('react');

function Electrics (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.1668 0.25V7.83333H15.0418L5.8335 19.75V12.1667H0.958496L10.1668 0.25Z","fill":"#0A9828"}));
}

Electrics.defaultProps = {"viewBox":"0 0 16 20","fill":"none"};

module.exports = Electrics;

Electrics.default = Electrics;
